import { ComponentType } from '@angular/cdk/portal';
import { ISnackbarBase } from './snackbar-base.model';

export class ModelSnackBarDetails implements ISnackbarBase {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    componentRef: ComponentType<any>;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    callbackOnAction: ((response?: any) => void) | undefined;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    data: any;

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(componentRef: ComponentType<any>, callbackOnAction?: (response?: any) => void) {
        this.componentRef = componentRef;
        this.callbackOnAction = callbackOnAction;
    }
}
